export default __webpack_public_path__ + "static/media/oscer-pres-amenorrhoea.41ddde91.svg";